import type { PokerCashGames } from '@ps/web-martech-cms-types';

import type { WidgetEffectParams } from '@swf/core/store';

import type { WidgetDispatch } from './types';

export const effects = {
  async preload(_payload: undefined, { dispatch, widget }: WidgetEffectParams<PokerCashGames>) {
    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    widget.unmount.subscribe(() => widgetDispatch.clear());
  }
};
